<template>
  <b-modal
    ref='roleLinkedModal'
    id='roleLinkedModal'
    header-bg-variant='info'
    header-text-variant='light'
    size='xl'
    title="O Cargo esta vinculado à hierarquia"
    @show='showModal()'
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
  >
    <b-overlay
      :show='loadingHierarchical'
      rounded
      no-center
      opacity='0.8'
      spinner-small
      spinner-variant='primary'
      class='d-inline-block w-100'
    >
      <section class='modal-font-family' v-if="sectorsRoles && sectorsRoles.length > 0">
        <p>
          <strong class='text-danger'>Atenção: </strong>
          O cargo <strong>{{ role.name }}</strong> está vinculado aos setores abaixo.
        </p>
        <p>
          Selecione os setores que terão as informações atualizadas.
        </p>
        <section class="sectors">
          <section
            class="mb-3"
            v-for="(sectorRole, i) in sectorsRoles"
            :key="`${sectorRole._id}_${i}`"
          >
            <p class="mb-0 sector-name">Setor: {{ sectorRole.sector && sectorRole.sector.name }}</p>
            <section class="mt-1">
              <section class="d-flex align-items-center">
                <b-icon
                  class="mr-2"
                  icon="chevron-down"
                >
                </b-icon>
                <b-form-checkbox
                  :id="sectorRole._id"
                  :name="sectorRole._id"
                  :value="sectorRole._id"
                  v-model="selectedSectorRoleIds"
                >
                  <p class="mb-1 role-name">Cargo: {{ sectorRole.role && sectorRole.role.name }}</p>
                </b-form-checkbox>
              </section>
            </section>
          </section>
        </section>
      </section>

      <template v-slot:overlay>
        <section class='text-center modal-font-family'>
          <b-spinner
            style='width: 2.5rem; height: 2.5rem'
            variant='primary'
            label='Large Spinner'
          ></b-spinner>
          <h5 class='text-primary text'>
            Buscando a hierarquia vinculada ao produto...
          </h5>
        </section>
      </template>
    </b-overlay>

    <template #modal-footer>
      <section class='w-100 d-flex modal-font-family'>
        <b-button
          class="w-50 mr-1"
          variant="danger"
          @click='closeModal()'
        >
          <span>Cancelar</span>
        </b-button>

        <b-button
          class="w-50 ml-1"
          variant="success"
          :disabled="disabled"
          @click='setSelected()'
        >
          <span>OK</span>
        </b-button>
      </section>
    </template>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'RoleLinkedModal',
  components: {},
  props: {
    role: {
      type: Object,
      required: false,
      default: Object
    },
    sectorsRoles: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data() {
    return {
      loadingHierarchical: false,
      selectedSectorRoleIds: []
    }
  },
  computed: {
    ...mapGetters('companyLegalConsultation', {
      importedCompany: 'importedCompany'
    }),
    disabled() {
      return !(this.selectedSectorRoleIds && this.selectedSectorRoleIds.length > 0)
    }
  },
  methods: {
    ...mapActions('productLegalConsultation', {
      handleGetProductLegalConsultationHierarchical: 'handleGetProductLegalConsultationHierarchical'
    }),
    ...mapActions('sectorRole', {
      handleGetByRole: 'handleGetByRole'
    }),

    async showModal() {
      try {
        this.selectedSectorRoleIds = []
      } catch (e) {
      }
    },

    setSelected() {
      console.log(this.selectedSectorRoleIds)
      this.$emit('setSelected', {
        sectorRoleIds: this.selectedSectorRoleIds,
      })
    },

    closeModal() {
      this.$bvModal.hide('roleLinkedModal')
    },
  },
  created() {
  }
}
</script>

<style lang='scss' scoped>
.alert-container {
  background: #FFF3E0;
  border-left: 4px solid #FF9800;
  border-radius: 4px;
  padding: 20px;
  margin-bottom: 20px;
}

.alert-title {
  color: #E65100;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
}

.alert-message {
  color: #262626;
  font-size: 15px;
  line-height: 1.6;
  margin: 10px 0;

  strong {
    font-weight: 700;
    color: #022245;
  }
}

.sectors {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(33%, auto));

  .title {
    font-weight: 700;
    font-size: 18px;
    color: #262626;
  }

  .sector-name {
    font-weight: 600;
    font-size: 15px;
    color: #000000;
  }

  .role-name {
    font-weight: 500;
    font-size: 15px;
    color: #000000;
  }

  .line {
    border-left: 1px solid #9C9C9C;
  }

  .product-name {
    font-weight: 400;
    font-size: 15px;
    color: #000000;
  }
}
</style>
